import RealtimeRetentionCo from '../RealtimeRentationCo';
import React, { useContext, useMemo } from 'react';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

const RealtimeRentationContext = (props: any) => {
  const { style, id, config, refArray,index, data: propsData} = props;
  const { dataKey, apiDataKey, event} = config || {};
  const { [apiDataKey]: apiData } = props?.data || {};
  const  { filterVal } = useContext(FilterContext);
  
  const { data, eventData} = useMemo(()=> {
    let isLoading = true;
    let isError = false;
    let componentData : any = [];
    let eventData : any = [];
    if(event && Object.keys(event).length !== 0 && event.show === true){
      const apiEvent = props?.data?.[event.dataKey];
      componentData = apiData?.data?.[dataKey];
      isLoading = apiData?.loading || apiEvent?.loading;
      isError = apiData?.errorMsg || apiEvent?.errorMsg;
      eventData = apiEvent?.data?.[event.valueKey];
    }else{
      if(apiData){
        componentData = apiData?.data?.[dataKey];
        isLoading = apiData?.loading;
        isError = apiData?.errorMsg;
      }
    }

    return {
      data: {
        componentData,
        loading: isLoading,
        errorMsg: isError,
        ...propsData
      },
      eventData
    };
  },[JSON.stringify(props?.data), dataKey, event]);

  return (
    <>
      <div className='margin-t-20 table-line' style={style} id={id} ref={refArray?.[index]}>
        <RealtimeRetentionCo
          data={data}
          config={config}
          formValue={filterVal}
          event={event}
          eventData={eventData}
        />
      </div>
    </>
  );
};

export default RealtimeRentationContext;